export function handleMenuHover() {
    const menuItems = document.querySelectorAll('.menu-item a');
  
    menuItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        menuItems.forEach((otherItem) => {
          if (otherItem !== item) {
            otherItem.classList.add('menu-item--inactive');
          }
        });
      });
  
      item.addEventListener('mouseleave', () => {
        menuItems.forEach((otherItem) => {
          otherItem.classList.remove('menu-item--inactive');
        });
      });
    });
  }